import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import {
  logout,
} from '../../helpers/storage';

const LogoutModule = () => {
  const history = useHistory();
  useEffect(() => {
    logout();
    history.push('/login');
  }, []);

  return null;
};

export default LogoutModule;
